/** Not an error screen: nothing is deleted, the 90 days govern visibility only. */
import { useTranslation } from 'react-i18next'

import MyPayslips from '../pages/payroll/MyPayslips'
import ImpersonationBanner from './ImpersonationBanner'
import { accountHandle } from '../lib/password'
import type { User } from '../lib/types'

export default function LeaverPayslipsOnly({ user }: { user: User }) {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-screen flex-col bg-slate-50 dark:bg-slate-900">
      <ImpersonationBanner user={user} />
      <div className="mx-auto w-full max-w-5xl space-y-4 p-6">
        <div className="space-y-2 rounded-xl border border-amber-200 bg-amber-50 p-4 dark:border-amber-800 dark:bg-amber-950">
          <h1 className="font-semibold text-amber-900 dark:text-amber-100">
            {t('hr.leaverTitle')}
          </h1>
          <p className="text-sm text-amber-800 dark:text-amber-200">{t('hr.leaverBody')}</p>
          {/*
             Shown for the same reason `NoAccessLevel` shows it: someone querying this as an
             administrator needs to say which account they are looking at.
          */}
          <p className="text-sm text-amber-700 dark:text-amber-300">
            {t('hr.leaverSignedInAs', { email: accountHandle(user) })}
          </p>
        </div>
        <MyPayslips />
      </div>
    </div>
  )
}
